/* eslint-disable react/no-danger */
import React, { useContext, useEffect, useState } from 'react';
import _, { isEmpty } from 'lodash';
import BoxedContainer from './layouts/BoxedContainer';
import DownloadableItem from './layouts/DownloadableItem';
import getFileSize from '../helpers/get-file-size';
import Sprites from '../components/Sprites';
import { getTranslationByKey } from '../helpers/translation-helper';
import { DWTCContext } from '../utils/context';

function FreeZoneApplicationTemplates({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const placeholderText = _.get(data, 'placeholder', '');
  const tableItems = _.get(data, 'tableItems', []);
  const [Search, setSearch] = useState('');
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => setToggle((prev) => !prev);
  const handleSearchInput = (e) => setSearch(e.target.value);

  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const handleSelect = (event) => {};

  const resolveFileSize = async () => {
    const mapped = await Promise.all(
      _.map(tableItems, async (item) => {
        const fileSize = _.get(item, 'content.fileSize', '');
        _.set(item, 'content.fileSize', fileSize);
        return item;
      }),
    );

    setItems(mapped);
  };

  useEffect(() => {
    resolveFileSize();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [Search, tableItems]);

  const handleSearch = () => {
    const newFilteredItems = _.filter(tableItems, (item) => {
      const itemTitle = _.get(item, 'content.title', '');
      const itemText = _.get(item, 'content.text', '');
      if (Search) {
        return (
          _.includes(_.toLower(itemTitle), _.toLower(Search)) ||
          _.includes(_.toLower(itemText), _.toLower(Search))
        );
      }
      return true;
    });
    setFilteredItems(newFilteredItems);
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const generatePaginationNumbers = () => {
    const maxPageNumbers = 2;
    const pageNumbers = [];
    const firstPage = 1;
    const lastPage = totalPages;

    if (totalPages > 1) {
      pageNumbers.push(firstPage);

      let startPage = Math.max(2, currentPage - maxPageNumbers);
      let endPage = Math.min(totalPages - 1, currentPage + maxPageNumbers);

      if (currentPage <= maxPageNumbers) {
        endPage = Math.min(maxPageNumbers * 2 + 1, totalPages - 1);
      } else if (currentPage >= totalPages - maxPageNumbers) {
        startPage = Math.max(totalPages - maxPageNumbers * 2, 2);
      }

      if (startPage > 2) {
        pageNumbers.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages - 1) {
        pageNumbers.push('...');
      }

      pageNumbers.push(lastPage);
    }

    return pageNumbers;
  };

  const { translations } = useContext(DWTCContext);

  return (
    <section id={id}>
      <div className="bg-white pt-12.5 lg:pt-25 pb-5 lg:pb-12.5">
        <BoxedContainer>
          <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-10 lg:gap-20">
            <div className="col-span-6 lg:col-span-12 flex flex-col items-center gap-5">
              <div
                className="child:text-clamp20to40 child:ltr:!font-URWDINMedium 
                child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3]
                last:child:!m-0 child:text-center"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <div className="py-px bg-red w-10 lg:w-12.5" />
              <div
                className="child:text-clamp12to18 child:ltr:!font-URWDINRegular 
                child:rtl:!font-GESSTwoDWTCLight child:leading-1.4
                last:child:!m-0 child:text-center col-span-6"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
          </div>
        </BoxedContainer>
      </div>
      <div className="bg-white pb-6 lg:pb-12.5">
        <BoxedContainer>
          <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-6 lg:gap-10">
            <div
              className="col-span-6 lg:col-span-12 flex flex-col items-center gap-5 lg:grid
              lg:grid-cols-12">
              <div
                className="w-full lg:col-span-3 text-clamp14to18
                  ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium text-[#231F20]">
                {placeholderText}
              </div>
              <input
                placeholder={getTranslationByKey(
                  translations,
                  'Search for an activity, license or keyword',
                )}
                className="py-3.5 px-4 w-full lg:col-span-5 border focus:outline-[#979797] 
                border-[#979797] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight"
                value={Search}
                onChange={handleSearchInput}
              />
              <div className="hidden lg:col-span-2 lg:flex w-full">
                <button
                  type="button"
                  onClick={handleSearch}
                  className="py-3 rtl:pt-3 ltr:pt-4 px-12 md:px-14 bg-red rounded-full 
                  text-white tracking-widest
                  w-fit uppercase ltr:font-URWDINBold h-8 md:h-[50px]
                  rtl:font-GESSTwoDWTCMedium hover:bg-[#B53B50] duration-300">
                  {getTranslationByKey(translations, 'Search')}
                </button>
              </div>
            </div>
          </div>
        </BoxedContainer>
      </div>
      <BoxedContainer className="flex justify-center pt-0 lg:pt-6 lg:hidden">
        <button
          type="button"
          onClick={handleSearch}
          className="pb-3 rtl:pt-[7px] ltr:pt-[10px] px-5 bg-red rounded-full text-white uppercase 
          tracking-widest max-w-68
          w-fit ltr:font-URWDINBold h-8 text-[11px]
          rtl:font-GESSTwoDWTCMedium">
          {getTranslationByKey(translations, 'Search')}
        </button>
      </BoxedContainer>
      <BoxedContainer>
        <div className="w-full flex flex-col items-center">
          <div className="w-full grid grid-cols-12 gap-[15px] lg:gap-7.5 mt-6 lg:mt-0">
            {_.map(currentItems, (templateItem, key) => (
              <div
                key={key}
                className="col-span-12 md:col-span-6 lg:col-span-4 px-4 py-5 md:p-5 flex gap-3
              lg:gap-[25px] border border-[#ccc] bg-[#f7f7f7] md:bg-[#FAFAFA]">
                <DownloadableItem type="template" index={key} data={templateItem} />
              </div>
            ))}
          </div>
          {filteredItems.length > 0 && totalPages > 1 && (
            <div
              className="flex justify-center w-auto gap-2 lg:gap-4 pt-[30px] lg:pt-[54px] mx-auto 
            [&>button]:min-w-[40px] [&>button]:font-URWDINRegular [&>button]:min-h-[40px]
            [&>button]:text-[14px] [&>button]:md:text-[16px] [&>button]:lg:text-[18px]">
              <button
                type="button"
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className={`text-[16px] md:text-[20px] lg:text-[20px] 
                ltr:!font-URWDINMedium rtl:!font-GESSTwoDWTCMedium text-[#231F20]
              ${currentPage === 1 ? 'cursor-not-allowed opacity-50' : ''}`}>
                {getTranslationByKey(translations, 'Previous')}
              </button>
              {generatePaginationNumbers().map((pageNumber, index) => (
                <React.Fragment key={index}>
                  {pageNumber === '...' ? (
                    <span className="py-1 min-h-[40px]">...</span>
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        if (pageNumber !== '...') {
                          paginate(pageNumber);
                        }
                      }}
                      className={`border px-3 py-1 ${
                        currentPage === pageNumber
                          ? 'text-white bg-red border-red'
                          : 'text-[#333] bg-white border-[#E6E6E6]'
                      }`}>
                      {pageNumber}
                    </button>
                  )}
                </React.Fragment>
              ))}
              <button
                type="button"
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`text-[16px] md:text-[20px] lg:text-[20px] ltr:!font-URWDINMedium 
                rtl:font-GESSTwoDWTCMedium text-[#231F20] 
              ${currentPage === totalPages ? 'cursor-not-allowed opacity-50' : ''}`}>
                {getTranslationByKey(translations, 'Next')}
              </button>
            </div>
          )}
          {filteredItems.length === 0 && (
            <div className="text-center mt-6">
              {getTranslationByKey(translations, 'No results found.')}
            </div>
          )}
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneApplicationTemplates;
